import React from "react";
import { Compass, ShieldAlert, ArrowLeft, AlertTriangle, CheckCircle2 } from "lucide-react";
import {
  Brain,
  ShieldCheck,
  Clock,
  HeartHandshake,
} from "lucide-react";

const BENEFITS = [
  {
    icon: Brain,
    title: "قرارات أوضح",
    desc: "تعرف بالضبط ما الذي يناسب حالتك قبل البدء بأي إجراء.",
    testid: "benefit-clear",
  },
  {
    icon: ShieldCheck,
    title: "أخطاء أقل",
    desc: "نساعدك على تجنّب الأخطاء التي تكلّف وقتاً ومالاً وقد تؤخر إقامتك.",
    testid: "benefit-fewer-mistakes",
  },
  {
    icon: Clock,
    title: "توفير في الوقت",
    desc: "خطوات واضحة ومباشرة بدلاً من البحث والتشتّت بين المصادر.",
    testid: "benefit-time",
  },
  {
    icon: HeartHandshake,
    title: "راحة بال أكبر",
    desc: "دعم باللغة العربية ومتابعة لوضعك حتى تحصل على خطوة تالية واضحة.",
    testid: "benefit-peace",
  },
];

export default function Benefits() {
  return (
    <section
      id="benefits"
      className="py-20 lg:py-24 bg-slate-50"
      data-testid="benefits-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-start max-w-2xl mb-12">
          <div className="text-emerald-700 text-sm font-semibold mb-3">
            لماذا iqama.pl
          </div>
          <h2 className="font-tajawal text-3xl sm:text-4xl font-bold text-slate-900 leading-tight">
            لا تحتاج أن تبدأ بالحيرة — ابدأ بقرار واضح
          </h2>
          <p className="mt-3 text-base md:text-lg text-slate-600">
            هدفنا أن يخرج كل شخص من أول تواصل بفكرة واضحة عمّا يجب فعله
            وما لا يجب فعله.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={i}
                className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow"
                data-testid={b.testid}
              >
                <div className="w-12 h-12 rounded-xl bg-slate-900 text-emerald-400 flex items-center justify-center mb-5">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="font-tajawal text-lg font-bold text-slate-900 mb-2">
                  {b.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">
                  {b.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
